import MetaTags from '../components/MetaTags';
import React from 'react';
import { 
  FaBuilding, 
  FaTools, 
  FaFireExtinguisher,
  FaCheck
} from 'react-icons/fa';
import { Link } from 'react-router-dom';

const services = [
  {
    id: 'ofis-temizligi',
    title: 'Ofis Temizliği',
    description: 'Çalışma alanlarınızın hijyenik ve temiz olması için özel ofis temizlik hizmetleri sunuyoruz.',
    icon: <FaBuilding className="text-blue-500 text-2xl" />,
    features: [
      'Ofis masalarının temizliği',
      'Zemin temizliği ve cilalama',
      'Cam ve pencere temizliği',
      'Mutfak ve dinlenme alanlarının temizliği',
      'Tuvalet ve lavaboların dezenfeksiyonu'
    ]
  },
  {
    id: 'tadilat-sonrasi',
    title: 'Tadilat Sonrası Temizlik',
    description: 'Tadilat sonrası oluşan toz, kir ve inşaat atıklarının temizliği için profesyonel hizmet sunuyoruz.',
    icon: <FaTools className="text-blue-500 text-2xl" />,
    features: [
      'İnşaat tozu ve kalıntılarının temizlenmesi',
      'Zemin ve duvar temizliği',
      'Cam ve pencere temizliği',
      'Derin kiri ve yapışkan kalıntıların çıkarılması',
      'Kokudan arındırma işlemleri'
    ]
  },
  {
    id: 'yangin-sonrasi',
    title: 'Yangın Sonrası Temizlik',
    description: 'Yangın sonrası oluşan is, duman ve koku kalıntılarının temizliği için özel yöntemler kullanıyoruz.',
    icon: <FaFireExtinguisher className="text-red-500 text-2xl" />,
    features: [
      'Duman ve is kalıntılarının temizlenmesi',
      'Kokudan arındırma işlemleri',
      'Yüzeylerin özel solüsyonlarla temizliği',
      'Havalandırma sistemlerinin temizliği',
      'Son kontroller ve dezenfeksiyon'
    ]
  },
  {
    id: 'dis-cephetemizligi',
    title: 'Dış Cephe & Cam Temizliği',
    description: 'Binaların dış cephe ve cam temizliği için profesyonel çözümler sunuyoruz.',
    icon: <FaBuilding className="text-blue-500 text-2xl" />,
    features: [
      'Dış cephe yüzey temizliği',
      'Cam ve pencere temizliği',
      'Kaldırım ve giriş alanı temizliği',
      'Özel kimyasallar ile leke çıkarma',
      'Yüzey koruma uygulamaları'
    ]
  }
];

const ServicesPage = () => {
  const baseUrl = window.location.protocol + '//' + window.location.host;
  
  return (
    <div className="bg-gray-50 py-16">
      <MetaTags 
        title="Hizmetlerimiz"
        description="Bektaş Temizlik olarak sunduğumuz profesyonel temizlik hizmetlerimizi keşfedin. Hizmetlerimiz hakkında detaylı bilgi alın."
        keywords="temizlik hizmetleri, temizlik fiyatları, ofis temizliği, tadilat sonrası temizlik, profesyonel temizlik şirketleri, haftalık temizlik hizmeti"
      />
      
      <div className="container mx-auto px-4 py-12 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Hizmetlerimiz</h2>
          <p className="text-gray-600 max-w-2xl mx-auto text-lg">
            Profesyonel ve güvenilir temizlik çözümlerimizle yanınızdayız.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {services.map((service, index) => {
            
            return (
              <div 
                key={service.id}
                className="bg-gradient-to-br from-blue-50 to-blue-100 border border-blue-100 rounded-xl overflow-hidden shadow-sm hover:shadow-2xl hover:shadow-blue-200/50 transition-all duration-300 hover:-translate-y-1"
              >
                <div className="p-8 h-full flex flex-col">
                  <div className="flex justify-center mb-6">
                    <div className="bg-white/80 p-4 rounded-xl backdrop-blur-sm">
                      {React.cloneElement(service.icon, { className: "text-blue-600 text-2xl" })}
                    </div>
                  </div>
                  
                  <h3 className="text-xl font-bold text-gray-800 mb-3 text-center">{service.title}</h3>
                  
                  <p className="text-gray-600 text-center mb-6 leading-relaxed">
                    {service.description}
                  </p>
                  
                  <div className="space-y-3 mb-8">
                    {service.features.map((feature, idx) => (
                      <div key={idx} className="flex items-start">
                        <FaCheck className="text-green-500 mt-0.5 mr-3 flex-shrink-0" />
                        <span className="text-gray-700 text-sm">{feature}</span>
                      </div>
                    ))}
                  </div>
                  
                  <div className="mt-auto">
                    <Link
                      to={`/hizmetler/${service.id}`}
                      className="block w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-6 rounded-lg text-center transition-colors duration-200"
                    >
                      Hizmeti İncele
                    </Link>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ServicesPage;
